import * as w from '../../../services/webhook';
import * as a from '../actions/app';
import * as c from '../services/config';
import { ActionTypes } from '../types/action-types';
import { IRequestConfigMap } from '../types/config';

export const loadConfig = (accessToken: string, tenantId: string) => async dispatch => {
    const config = await c.getConfig(accessToken, tenantId)
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
}

export const installSchema = (accessToken: string, tenantId: string, enable: boolean) => async dispatch => {
    const config = await c.updateConfig(accessToken, tenantId, {
        enabled: enable
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
    if (!config.enabled) {
        dispatch(a.expandConfigView(false));
        dispatch(a.expandBYODView(false));
    }
};

export const saveMappings = (accessToken: string, tenantId: string, mappings: IRequestConfigMap) => async dispatch => {
    const config = await c.updateConfig(accessToken, tenantId, {
        mappings
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
};

export const generateWebhook = (accessToken: string, tenantId: string) => async dispatch => {
    const id = await w.generateWebhook(accessToken, tenantId)
    const config = await c.updateConfig(accessToken, tenantId, {
        webhook: id
    })
    dispatch({
        type: ActionTypes.CONFIG_LOADED,
        config,
    })
};



// WEBPACK FOOTER //
// ./src/sub-projects/openweathermap/actions/config.ts